import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Heading4,
} from '@gousto-internal/citrus-react'

type ResponsivePlacement = [string | null, string | null, string | null, string | null]

type Props = {
  heading: string
  children: React.ReactNode
  gridColumn?: ResponsivePlacement
  gridRow?: ResponsivePlacement
}

export const FooterColumn = ({ heading, children, gridColumn, gridRow }: Props) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    gap={2}
    color={Color.White}
    width={['auto', null, null, '200px']}
    gridColumn={gridColumn}
    gridRow={gridRow}
  >
    <Heading4 size={[4, null, null, 5]} color={Color.White} fontWeight={FontWeight.Bold}>
      {heading}
    </Heading4>
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      alignItems={AlignItems.FlexStart}
      gap={2}
    >
      {children}
    </Box>
  </Box>
)
